import { colors } from '../../Colors/colors'

export const crmItemLayouts = {
   light: {},
   dark: {}
}
